<app-popup-layout #modal>
  <div class="modal-container p-5">
    <p class="title">Create eRUPI Voucher Account</p>
    <img src="assets/home/erupi-create.svg" class="enkash-card mt-12 mb-4" alt="eRupi Voucher Account Create" />
    <section class="w-100" [formGroup]="form">
      <div class="d-flex flex-col mt-8">
        <label class="input-label m-0">Account Name</label>
        <input class="px-3" type="text" placeholder="Account Name" class="form-control"
          formControlName="accountTitle" />
      </div>

      <section class="d-flex mt-32 justify-center align-content-center">
        <button mat-flat-button color="accent" class="me-4" (click)="modal.dismiss()">
          I'll Create Later
        </button>

        <button mat-flat-button color="primary" [appLoaderButton]="formActionRequestState()" [disabled]="form.invalid"
          (click)="onSave()">
          Confirm & Continue
        </button>
      </section>
    </section>
  </div>
</app-popup-layout>